import * as React from "react";
import type { SVGProps } from "react";
const SvgWaterSlide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.5 9.292a2 2 0 0 1-.1-.122v.01c-.38-.55-.53-1.21-.41-1.87.08-.46.29-.86.57-1.19-.06-.06-.11-.11-.16-.18-.38-.55-.53-1.21-.41-1.87.24-1.36 1.53-2.28 2.89-2.03l6.88 1.21c1.36.24 2.27 1.54 2.03 2.9-.08.45-.28.85-.57 1.19.47.55.7 1.29.57 2.05-.04.23-.12.44-.22.65l6.31 1.11c.5.09.96.33 1.32.69.5.47.79 1.13.79 1.81v1.85a2.5 2.5 0 0 1-4.99.22l-4.01-.71V17c0 .55-.45 1-1 1s-1-.45-1-1v-2.34l-5-.88V17c0 .55-.45 1-1 1s-1-.45-1-1v-3.58a2.5 2.5 0 0 1-2.01-2.89c.08-.45.29-.85.57-1.18zm8.92-.842L4.53 7.24l.01-.02a.5.5 0 0 0-.58.41c-.03.17.04.31.08.37.04.07.14.18.32.21l6.89 1.22c.17.03.31-.03.37-.08a.45.45 0 0 0 .21-.32.514.514 0 0 0-.41-.58m8.41 4.84-.03-.03a.6.6 0 0 0-.27-.14L4.52 10.47h-.09c-.23 0-.45.17-.49.41-.04.27.14.53.41.58l13.81 2.44c.48.08.83.49.83.98v.62c0 .28.22.5.5.5s.5-.22.5-.5v-1.85c0-.18-.1-.3-.16-.36m-8.4-8.07L4.54 4.01 4.55 4a.5.5 0 0 0-.58.41c-.03.17.04.31.08.37.04.07.14.18.32.21l6.89 1.22c.26.04.53-.14.58-.41a.514.514 0 0 0-.41-.58"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M21.18 19.42c.33-.45.95-.55 1.4-.23h-.02c.45.33.55.95.23 1.4-.64.89-1.67 1.42-2.76 1.42h-.14c-1.05 0-2.08-.53-2.72-1.42-.27-.37-.68-.58-1.17-.58-.5 0-.94.2-1.21.58-.65.92-1.75 1.42-2.83 1.42h-.07c-1.05 0-2.08-.53-2.72-1.42-.27-.37-.68-.58-1.17-.58-.5 0-.94.2-1.21.58-.65.92-1.76 1.42-2.83 1.42h-.07c-1.05 0-2.08-.53-2.72-1.42-.32-.45-.22-1.08.23-1.4s1.08-.22 1.4.23c.27.37.66.58 1.17.58.5 0 .94-.2 1.21-.58.64-.89 1.67-1.42 2.76-1.42h.14c1.05 0 2.08.53 2.72 1.42.27.36.69.58 1.14.58H12c.49 0 .92-.21 1.18-.58.64-.89 1.67-1.42 2.76-1.42h.14c1.05 0 2.08.53 2.72 1.42.27.36.69.58 1.14.58H20c.49 0 .92-.21 1.18-.58"
    />
  </svg>
);
export default SvgWaterSlide;
